import { initContract } from '@ts-rest/core';
import { z } from 'zod';
////////////////////////////////////////////////////////////////////////////////
// getDashboard
////////////////////////////////////////////////////////////////////////////////
export const ChartData = z.strictObject({
    name: z.string(),
    value: z.number(),
});
export const GetDashboardResponse = z.strictObject({
    claimsLastYearByType: z.array(ChartData),
    claimsThisYearByType: z.array(ChartData),
    documentsLastYearByDecision: z.array(ChartData),
    documentsThisYearByDecision: z.array(ChartData),
    payoutLastYear: z.number(),
    payoutThisYear: z.number(),
});
////////////////////////////////////////////////////////////////////////////////
// contract
////////////////////////////////////////////////////////////////////////////////
const c = initContract();
export const dashboardContract = c.router({
    getDashboard: {
        method: 'GET',
        path: '/get-dashboard',
        responses: {
            200: GetDashboardResponse,
        },
    },
}, { strictStatusCodes: true, pathPrefix: '/dashboard' });
